import type { Timestamp } from '@/models/common';

import i18n from '@/plugins/i18n';

/**
 * Formats an iso8601 formatted date to readable format.
 */
export function formatDate(date?: Timestamp | null): string {
  if (!date) {
    return '';
  }

  return dayjs(date).format('DD.MM.YYYY');
}

export function formatDateTime(date?: Timestamp | null): string {
  if (!date) {
    return '';
  }

  return dayjs(date).format('DD.MM.YYYY HH:mm');
}

export function convertUTCToLocalDate(date: string): string {
  return dayjs(date).format('YYYY-MM-DD');
}

interface PersonLike {
  firstName: string;
  lastName: string;
  anonymized?: boolean;
}

function isAnonymized(person: PersonLike) {
  const ANONYMIZED = '********';
  return person.anonymized || (person.firstName === ANONYMIZED && person.lastName === ANONYMIZED);
}

export function formatName(person?: PersonLike | null) {
  if (!person) {
    return '';
  }

  if (isAnonymized(person)) {
    return i18n.global.t('common.deletedUser');
  }

  return `${person.firstName} ${person.lastName}`;
}
